import { render } from "./uploadPajamasExcelModal.vue?vue&type=template&id=2f7e7414&ts=true"
import script from "./uploadPajamasExcelModal.vue?vue&type=script&lang=ts"
export * from "./uploadPajamasExcelModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__